export const DopSidebarData = [
    {
        title: 'Dashboard',
        path: '/admin/dashboard',
    },
    {
        title: 'Applications',
        subNav: [
            {
                title: 'New Applications',
                path: '/new_applications',
            },
            {
                title: 'Regional Approvals',
                path: '/regional_approvals',
            },
        ]
    },
    {
        title: 'Operations',
        subNav: [
            {
                title: 'Declined Applications',
                path: '/declined_applications',
            },
            {
                title: 'Responses',
                path: '/#',
                subNav: [
                    {
                        title: 'Update Response',
                        path: '/update_response',
                    },
                    {
                        title: 'Activation Response',
                        path: '/activation_response',
                    },
                    {
                        title: 'Messages Response',
                        path: '/messages_response',
                    },
                ],
            },
            {
                title: 'Regional Reports',
                path: '/regional_report_list',
            },

        ]
    },
    {
        title: 'Membership',
        subNav: [
            {
                title: 'Global Members',
                path: '/global_members',
            },
            {
                title: 'Regional Membership',
                path: '/admin_regional_members',
            },
            {
                title: 'Active Members',
                path: '/active_members',
            },
            {
                title: 'InActive Members',
                path: '/inactive_members',
            },
        ]
    },
    {
        title: 'Card Management',
        subNav: [
            {
                title: 'Global Cards',
                path: '/global_cards',
            },
            {
                title: 'Pending Cards',
                path: '/pending_cards',
            },
            {
                title: 'Pending Confirmation',
                path: '/pending_confirmation',
            },
        ]
    },
    {
        title: 'Accounts',
        path: '/#',
        subNav: [
            {
                title: 'Payments',
                path: '/#',
                subNav: [
                    {
                        title: 'Payment Transactions',
                        path: '/payment_transactions',
                    },
                ],
            },
            {
                title: 'Ledgers',
                path: '/#',
                subNav: [
                    {
                        title: 'Ledger Accounts',
                        path: '/ledger_accounts',
                    },
                ],
            },
        ]
    },
    {
        title: 'Log Out',
        path: '/admin_logout',
    },

];

